import { EProductType } from './../../../enums/product-type.enum';
import { environment } from 'src/environments/environment';
import { Component, Input, OnInit } from '@angular/core';
import { ProductDigital } from 'src/app/models/product-digital.model';
import { ProductPresencial } from 'src/app/models/product-presencial.model';

@Component({
  selector: 'app-pillar-card-list',
  templateUrl: './pillar-card-list.component.html',
  styleUrls: ['./pillar-card-list.component.scss']
})
export class PillarCardListComponent implements OnInit {
  storageUrl = environment.BASE_STORAGE_URL;

  @Input() blueStripeTitle: string = 'Visão estratégica, Conhecimento, Protagonismo.'
  @Input() productList: ProductDigital[] | ProductPresencial[] = [];

  constructor() {

  }

  ngOnInit(): void {
    setTimeout(() => {
      this.btnHoverAnimation();
    }, 1000);
  }

  productType(type: EProductType): string {
    return type === EProductType.PRESENCIAL ? 'presencial' : 'digital';
  }

  btnHoverAnimation(): void {
    let btn = document.querySelectorAll('.product-card');
    for (let i = 0; i < btn.length; i++) {
      btn[i].addEventListener('mouseover', () => {
        let btnHTML = btn[i] as HTMLElement;
        btnHTML.classList.add('all-white');
        setTimeout(() => {
          btnHTML.classList.add('fade-all-white');
        }, 100);
      })
    }
    for (let i = 0; i < btn.length; i++) {
      btn[i].addEventListener('mouseout', () => {
        let btnHTML = btn[i] as HTMLElement;
        btnHTML.classList.remove('all-white');
        setTimeout(() => {
          btnHTML.classList.remove('fade-all-white');
        }, 100);
      })
    }
  }
}
